/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { MutableRefObject, useEffect } from 'react';

function useSemanticDialog(
  ref: MutableRefObject<HTMLDialogElement | null>,
  method: 'show' | 'showModal',
  open: boolean,
) {
  useEffect(() => {
    const dialog = ref.current;
    if (dialog) {
      if (open) {
        const show = dialog[method];
        if (typeof show === 'function') {
          show.call(dialog);
        }
      } else {
        const close = dialog.close;
        if (typeof close === 'function') {
          close.call(dialog);
        }
      }
    }
  }, [open, method, ref]);
}

export default useSemanticDialog;
